__turbopack_context__.v({
  "className": "D7tgcG_className",
});
